import { OnboardingImportModal } from '@pages/onboarding/views';
import { Typography, Button } from '@ui/components';
import { useTranslation } from 'react-i18next';
import React, { useState, FC } from 'react';
import { cn } from '@ui/utils';

export const AddVehiclesHeader: FC<React.ComponentPropsWithoutRef<'div'>> = (props) => {
  const { className, ...rest } = props;
  const { t } = useTranslation();

  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  return (
    <div className={cn('flex', className)} {...rest}>
      <Typography variant="h400" element="h1">
        {t('ONBOARDING.ADD_VEHICLES.ADD_VEHICLES')}
      </Typography>

      <div className="ml-auto flex items-center gap-6">
        <Typography>{t('ONBOARDING.ADD_VEHICLES.OR')}</Typography>

        <OnboardingImportModal setOpen={setIsImportModalOpen} open={isImportModalOpen}>
          <Button variant="secondary" size="small">
            {t('ONBOARDING.ADD_VEHICLES.IMPORT_DATA')}
          </Button>
        </OnboardingImportModal>
      </div>
    </div>
  );
};
